import styled from "styled-components";
import { ClaudeLogo } from "./AssistantLogos";

const weekPlan = [
  { day: "Mon", title: "Spicy vodka pasta", minutes: "30 min" },
  { day: "Tue", title: "Smash burgers", minutes: "25 min" },
  { day: "Wed", title: "Avocado toast & eggs", minutes: "15 min" },
  { day: "Thu", title: "Soup & fresh bread", minutes: "40 min" },
  { day: "Fri", title: "Breakfast-for-dinner pancakes", minutes: "35 min" },
];

/**
 * A static example chat in Claude: the assistant uses Bite to plan the week
 * and answers in plain text, the way a real Claude reply looks.
 * Shared by the home page and /connect. Extra props (e.g. data-reveal)
 * go on the outer window.
 */
export default function AssistantChatPreview(props) {
  return (
    <ChatWindow
      role="img"
      aria-label="Example chat in Claude: Claude uses Bite to plan five dinners from your favorites and adds them to your Bite meal plan"
      {...props}
    >
      <TitleBar aria-hidden="true">
        <WindowDots>
          <i />
          <i />
          <i />
        </WindowDots>
        <AppName>
          <ClaudeLogo size={18} style={{ color: "#d97757" }} />
          Claude
        </AppName>
      </TitleBar>

      <ChatBody aria-hidden="true">
        <UserMessage>
          Plan my dinners Mon–Fri from my Bite favorites, nothing over 45
          minutes.
        </UserMessage>

        <ToolCall>
          <span>
            <ToolIcon src="/bite-icon-1024.png" alt="" />
            Bite · Add to meal plan
          </span>
          <Chevron viewBox="0 0 12 12" width="12" height="12">
            <path d="M3 4.5 6 7.5 9 4.5" />
          </Chevron>
        </ToolCall>

        <Answer>
          <p>Here’s your week, all under 45 minutes:</p>
          <ol>
            {weekPlan.map(item => (
              <li key={item.day}>
                <strong>{item.day}</strong> – {item.title} ({item.minutes})
              </li>
            ))}
          </ol>
          <p>
            They’re in your Bite meal plan now. Should I make the shopping list?
          </p>
        </Answer>

        <Composer>
          Reply to Claude…
          <SendButton>
            <svg viewBox="0 0 12 12" width="12" height="12">
              <path d="M6 10V2M2.5 5.5 6 2l3.5 3.5" />
            </svg>
          </SendButton>
        </Composer>
      </ChatBody>
    </ChatWindow>
  );
}

const ChatWindow = styled.div`
  border: 1px solid #ece8de;
  border-radius: 20px;
  background: #faf9f5;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
  overflow: hidden;
`;

const TitleBar = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  height: 40px;
  padding: 0 16px;
  border-bottom: 1px solid #eeebe2;
`;

const WindowDots = styled.span`
  display: flex;
  gap: 6px;

  i {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background: #e2dfd6;
  }
`;

const AppName = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #3d3d3a;
  font-size: 0.82rem;
  font-weight: 650;
`;

const ChatBody = styled.div`
  display: grid;
  gap: 14px;
  padding: 22px 22px 20px;

  @media (max-width: 520px) {
    padding: 18px 16px 16px;
  }
`;

const UserMessage = styled.div`
  justify-self: end;
  max-width: 84%;
  padding: 10px 15px;
  border-radius: 14px;
  background: #f0eee6;
  color: #141413;
  font-size: 0.93rem;
  line-height: 1.45;
`;

const ToolCall = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 12px;
  border: 1px solid #e6e2d6;
  border-radius: 10px;
  background: #ffffff;
  color: #3d3d3a;
  font-size: 0.84rem;

  span {
    display: flex;
    align-items: center;
    gap: 9px;
  }
`;

const ToolIcon = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 5px;
  border: 1px solid #e6e2d6;
  display: block;
`;

const Chevron = styled.svg`
  fill: none;
  stroke: #8a877e;
  stroke-width: 1.5;
  stroke-linecap: round;
  stroke-linejoin: round;
`;

const Answer = styled.div`
  color: #141413;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 0.97rem;
  line-height: 1.55;

  && p {
    margin: 0;
    color: inherit;
    font-size: inherit;
    line-height: inherit;
    max-width: none;
  }

  ol {
    margin: 8px 0 10px;
    padding-left: 22px;
  }

  li {
    margin: 2px 0;
  }

  strong {
    font-weight: 700;
  }
`;

const Composer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 4px;
  padding: 12px 12px 12px 16px;
  border: 1px solid #e6e2d6;
  border-radius: 14px;
  background: #ffffff;
  color: #9a978f;
  font-size: 0.88rem;
`;

const SendButton = styled.span`
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #d97757;
  display: grid;
  place-items: center;

  path {
    fill: none;
    stroke: #ffffff;
    stroke-width: 1.6;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
`;
